// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OperacaoCompromissos_TimelineResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /dashboards/operacao_compromissos/timeline.
 *
 * Returns a per-bucket time series for compromissos in the filter window.
 * `bucket` query param picks the granularity (day|week|month) and the
 * controller echoes it back so the frontend doesn't have to remember the
 * request.
 *
 * `buckets` is sparse in the input direction but the controller densifies
 * it to one row per discrete bucket in the window (zero-fill) before
 * sending — see the model.
 */
import type { OperacaoCompromissos_TimelineBucketRow } from './OperacaoCompromissos_TimelineBucketRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface OperacaoCompromissos_TimelineResponseDados {
bucket: string
buckets: OperacaoCompromissos_TimelineBucketRow[]
}

export type OperacaoCompromissos_TimelineResponse = ApiResponse<OperacaoCompromissos_TimelineResponseDados>;

registerResponseContract('OperacaoCompromissos_TimelineResponse', {
  bucket:  { type: 'string',  required: true },
  buckets: {
    type: 'array',
    required: true,
    items: {
      bucket:         { type: 'string',  required: true },
      realizados_qtd: { type: 'number',  required: false },
      previstos_qtd:  { type: 'number',  required: false },
      cancelados_qtd: { type: 'number',  required: false },
    },
  },
})
